import Component from './component';

Component.defaultProps = {
    layoutContainerProps: null,
    descriptionProps: null,
};
export default Component;
